<template>
  <div class="">
    <sale-open v-if="tab === 'open'"></sale-open>
    <sale-entry-history v-if="tab === 'history'"></sale-entry-history>
    <sale-closed v-if="tab === 'closed'"></sale-closed>
  </div>
</template>
<script>
import SaleOpen from '@/view/sale/SaleOpen'
import SaleEntryHistory from '@/view/sale/SaleEntryHistory'
import SaleClosed from '@/view/sale/SaleClosed'

export default {
  components: {
    SaleOpen,
    SaleEntryHistory,
    SaleClosed
  },
  props: {
    tab: {
      type: String,
      default: 'open'
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/view/sale/components/TabContent.vue